import { NavLink, Outlet } from "react-router-dom";
import { contact, navItems } from "../../content/site";
import { clsx } from "../../utils/clsx";
import { BrandLogo } from "../BrandLogo/BrandLogo";
import { Button } from "../Button/Button";
import * as styles from "./Layout.css";

type FooterIconProps = {
  children: React.ReactNode;
};

function FooterIcon({ children }: FooterIconProps) {
  return (
    <span className={styles.footerIcon} aria-hidden="true">
      <svg className={styles.footerIconSvg} viewBox="0 0 24 24" focusable="false">
        {children}
      </svg>
    </span>
  );
}

function MailIcon() {
  return (
    <FooterIcon>
      <path d="M4 7.5h16v10H4z" />
      <path d="m4.5 8 7.5 5.5L19.5 8" />
    </FooterIcon>
  );
}

function ClockIcon() {
  return (
    <FooterIcon>
      <circle cx="12" cy="12" r="7.5" />
      <path d="M12 8v4.35l3 1.8" />
    </FooterIcon>
  );
}

export function Layout() {
  return (
    <div className={styles.pageShell}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <NavLink to="/" aria-label="Ayro Technologies home">
            <BrandLogo />
          </NavLink>
          <nav className={styles.nav} aria-label="Primary navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  clsx(styles.navLink, isActive && styles.navLinkActive)
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className={styles.headerCta}>
            <Button href="/contact" variant="dark">
              Discuss a project
            </Button>
          </div>
        </div>
        <nav className={styles.mobileNav} aria-label="Mobile navigation">
          {navItems.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) =>
                clsx(styles.navLink, isActive && styles.navLinkActive)
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <BrandLogo inverse />
            <p className={styles.footerText}>
              IT consulting, technical assessment, bespoke software, and delivery support
              for organisations that need practical engineering judgement.
            </p>
          </div>
          <div>
            <h2 className={styles.footerHeading}>Contact</h2>
            <ul className={styles.footerContactList}>
              <li>
                <a className={styles.footerContactItem} href={`mailto:${contact.email}`}>
                  <MailIcon />
                  <span>
                    <span className={styles.footerContactLabel}>Email</span>
                    <span className={styles.footerContactValue}>{contact.email}</span>
                  </span>
                </a>
              </li>
              <li className={styles.footerContactItem}>
                <ClockIcon />
                <span>
                  <span className={styles.footerContactLabel}>Working hours</span>
                  <span className={styles.footerContactValue}>
                    {contact.workingHours}
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <div>
            <h2 className={styles.footerHeading}>Pages</h2>
            <ul className={styles.footerList}>
              {navItems.map((item) => (
                <li key={item.href}>
                  <NavLink to={item.href}>{item.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
